export * from './admin-layout.component';



// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/containers/admin-layout/index.ts